var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "col-12 col-md-8 col-xl-5 offset-md-4 offset-xl-0 order-1 order-xl-2",
          attrs: { id: "quarterly-nav" }
        },
        [
          _c(
            "ol",
            { staticClass: "quarters" },
            _vm._l(_vm.model, function(quarter) {
              return _c(
                "li",
                { class: _vm.quarterClass(quarter.continuousReportPeriodId) },
                [
                  quarter.isOpen &&
                  !(_vm.currentPeriodId == quarter.continuousReportPeriodId)
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-link",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.navigateToQuarter(
                                quarter.continuousReportPeriodId
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                quarter.continuousReportPeriod.periodNumber
                              ) +
                              ". " +
                              _vm._s(_vm.$t("ContinuousReport.Quarter")) +
                              "\n            "
                          ),
                          _c(
                            "i",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.top.center",
                                  value: {
                                    content: _vm.$t(
                                      "ContinuousReport.QuarterDataValidationTooltip"
                                    ),
                                    classes: "error"
                                  },
                                  expression:
                                    "{ content: $t('ContinuousReport.QuarterDataValidationTooltip'), classes: 'error' }",
                                  modifiers: { top: true, center: true }
                                }
                              ],
                              staticClass:
                                "fas fa-exclamation-triangle fa-xs icon validation",
                              attrs: { tabindex: "0" }
                            },
                            [
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "ContinuousReport.QuarterDataValidationTooltip"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    : (quarter.hasBeenSent || quarter.pastDeadline) &&
                      !(_vm.currentPeriodId == quarter.continuousReportPeriodId)
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-link sent",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.navigateToQuarter(
                                quarter.continuousReportPeriodId
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                quarter.continuousReportPeriod.periodNumber
                              ) +
                              ". " +
                              _vm._s(_vm.$t("ContinuousReport.Quarter")) +
                              "\n            "
                          ),
                          quarter.hasBeenSent
                            ? _c(
                                "i",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.top.center",
                                      value: {
                                        content: _vm.$t(
                                          "ContinuousReport.QuarterHasBeenSent"
                                        )
                                      },
                                      expression:
                                        "{ content: $t('ContinuousReport.QuarterHasBeenSent') }",
                                      modifiers: { top: true, center: true }
                                    }
                                  ],
                                  staticClass: "fas fa-check icon green",
                                  attrs: { tabindex: "0" }
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "ContinuousReport.QuarterHasBeenSent"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm.currentPeriodId == quarter.continuousReportPeriodId
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-link selected",
                          attrs: { type: "button", disabled: "" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                quarter.continuousReportPeriod.periodNumber
                              ) +
                              ". " +
                              _vm._s(_vm.$t("ContinuousReport.Quarter")) +
                              "\n            "
                          ),
                          quarter.hasBeenSent
                            ? _c(
                                "i",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.top.center",
                                      value: {
                                        content: _vm.$t(
                                          "ContinuousReport.QuarterHasBeenSent"
                                        )
                                      },
                                      expression:
                                        "{ content: $t('ContinuousReport.QuarterHasBeenSent') }",
                                      modifiers: { top: true, center: true }
                                    }
                                  ],
                                  staticClass: "fas fa-check icon green",
                                  attrs: { tabindex: "0" }
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "ContinuousReport.QuarterHasBeenSent"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn btn-link",
                          attrs: { type: "button", disabled: "" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                quarter.continuousReportPeriod.periodNumber
                              ) +
                              ". " +
                              _vm._s(_vm.$t("ContinuousReport.Quarter")) +
                              "\n          "
                          )
                        ]
                      )
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-xl-7 order-2 order-xl-1" }, [
        _c("h2", { attrs: { tabindex: "-1" } }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("ContinuousReport.Collaboration.Title")) +
              "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-6" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t("ContinuousReport.TabInfo.Quarterly")))])
      ]),
      _vm._v(" "),
      !_vm.isReadOnly
        ? _c(
            "div",
            { staticClass: "required-fields-info-continuous-report col-6" },
            [
              _c("p", [
                _c("i", { staticClass: "fas fa-asterisk icon red" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("RequiredFieldsInfo")) +
                    "\n      "
                )
              ])
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.currentPeriodItem
      ? _c(
          "div",
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "h3",
                { staticClass: "col m-0" },
                [
                  _c("plain-text-control", {
                    attrs: {
                      title: "ContinuousReport.Collaboration.Volunteers.Title"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("radio-button-row", {
              key: _vm.radioButtonValueChanged + "volunteers",
              attrs: {
                title:
                  "ContinuousReport.Collaboration.Volunteers.HasVolunteers",
                required: true
              },
              model: {
                value: _vm.volunteers.hasVolunteers,
                callback: function($$v) {
                  _vm.$set(_vm.volunteers, "hasVolunteers", $$v)
                },
                expression: "volunteers.hasVolunteers"
              }
            }),
            _vm._v(" "),
            _vm.volunteers.hasVolunteers
              ? _c(
                  "div",
                  [
                    _c("numeric-input-row", {
                      attrs: {
                        title:
                          "ContinuousReport.Collaboration.Volunteers.Count",
                        id: "volunteercount",
                        required: true
                      },
                      model: {
                        value: _vm.volunteers.count,
                        callback: function($$v) {
                          _vm.$set(_vm.volunteers, "count", $$v)
                        },
                        expression: "volunteers.count"
                      }
                    }),
                    _vm._v(" "),
                    _vm.hasTargets
                      ? _c("check-box-dialog-row", {
                          attrs: {
                            id: "volunteerTargetsDialog",
                            title:
                              "ContinuousReport.Collaboration.Volunteers.TargetsRelated",
                            buttonLabel: "ContinuousReport.Button.SelectTarget",
                            displayOptionNames: false,
                            options: _vm.targets,
                            required: true
                          },
                          model: {
                            value: _vm.volunteers.targets,
                            callback: function($$v) {
                              _vm.$set(_vm.volunteers, "targets", $$v)
                            },
                            expression: "volunteers.targets"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("check-box-dialog-row", {
                      attrs: {
                        id: "volunteerTargetGroupsDialog",
                        title:
                          "ContinuousReport.Collaboration.Volunteers.TargetGroupsRelated",
                        buttonLabel:
                          "ContinuousReport.Button.SelectTargetGroup",
                        displayOptionNames: true,
                        options: _vm.targetGroupOptions,
                        required: true
                      },
                      model: {
                        value: _vm.volunteers.targetGroups,
                        callback: function($$v) {
                          _vm.$set(_vm.volunteers, "targetGroups", $$v)
                        },
                        expression: "volunteers.targetGroups"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "h3",
              {
                attrs: { id: "ContinuousReport.Collaboration.Partners.Title" }
              },
              [
                _c("plain-text-control", {
                  attrs: {
                    title: "ContinuousReport.Collaboration.Partners.Title"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("partners-control", {
              attrs: {
                model: _vm.currentPeriodItem.partners,
                targets: _vm.targets,
                targetGroups: _vm.targetGroupOptions
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-5" },
              [
                _c("text-area-row", {
                  attrs: {
                    id: "collaboration-notes",
                    title: "ContinuousReport.Notes.Collaboration",
                    instructionsKey:
                      "ContinuousReport.Notes.Collaboration_Instructions",
                    placeholder: "ContinuousReport.Notes.Placeholder",
                    showMaxLengthInPlaceholder: false,
                    maxLength: 5000,
                    rows: 10,
                    textAreaClasses: "notes"
                  },
                  model: {
                    value: _vm.currentPeriodItem.notes,
                    callback: function($$v) {
                      _vm.$set(_vm.currentPeriodItem, "notes", $$v)
                    },
                    expression: "currentPeriodItem.notes"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }